"use client";

import { content } from "@/config/content";

export default function FilterTabs({ active, onChange, filters }) {
  // 優先使用動態分類（從資料庫），fallback 到 config hardcode
  const tabs = [
    content.gallery.filterAll,
    ...(filters || content.gallery.filters),
  ];

  return (
    <div className="filter-tabs flex gap-1.5 md:gap-2 overflow-x-auto md:flex-wrap pb-2 px-1">
      {tabs.map((tab) => {
        const isActive = active === tab;
        return (
          <button
            key={tab}
            onClick={() => onChange(tab)}
            className="shrink-0 md:shrink px-4 py-2.5 text-sm min-h-[44px] transition-all duration-200"
            style={{
              borderRadius: "var(--radius-full)",
              fontFamily: "var(--font-body)",
              backgroundColor: isActive ? "var(--color-accent)" : "transparent",
              border: isActive
                ? "1px solid transparent"
                : "1px solid var(--color-cardBorder)",
              color: isActive
                ? "var(--color-accentText, #fff)"
                : "var(--color-textMuted)",
              fontWeight: isActive ? 600 : 400,
              letterSpacing: "0.02em",
            }}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
}
